import dayjs from 'dayjs'

import {
  AppointmentSearchResult,
  DCNotification,
  NotificationStyle,
  SimpleNotification,
} from '../../../__generated__/api'
import { formatCallbackTime } from '../../utils/text'

type AriaLabelParams = {
  t: (key: string) => string
  appointment: AppointmentSearchResult
  appointmentDate: dayjs.Dayjs
  isCallbackAppointment: boolean
  isRemoteAppointment: boolean
  isAlsoRemoteAppointment: boolean
}

export const buildAriaLabelForAppointment = ({
  t,
  appointment,
  appointmentDate,
  isCallbackAppointment,
  isRemoteAppointment,
  isAlsoRemoteAppointment,
}: AriaLabelParams): string => {
  const parts = [
    t('component.appointmentList.reserveButtonText'),
    appointment.specialistName,
    appointmentDate.format(isCallbackAppointment ? 'dd D.M.' : 'dd D.M. H:mm'),
  ]

  if (isCallbackAppointment) {
    const callbackTime = formatCallbackTime(appointmentDate)
    if (callbackTime) parts.push(callbackTime)
  } else {
    if (isRemoteAppointment) {
      parts.push(t('component.appointmentLocationDetails.onlyRemote'))
    } else {
      parts.push(appointment.locationName)
      if (isAlsoRemoteAppointment) {
        parts.push(t('component.appointmentLocationDetails.alsoRemote'))
      }
    }
  }

  return parts.join(', ')
}

export const isDCNotification = (
  value: DCNotification | SimpleNotification
): value is DCNotification => {
  return 'queueId' in value
}

export const isSimpleNotification = (
  value: DCNotification | SimpleNotification
): value is SimpleNotification => {
  return !('queueId' in value)
}

export const isWalkInNotification = (
  value: DCNotification | SimpleNotification
): value is SimpleNotification => {
  return isSimpleNotification(value) && value.style === NotificationStyle.WalkIn
}
